export default function formatDate(date) {
  if (date instanceof Date) {
    return `${date.getFullYear()}-${(`0${date.getMonth() + 1}`).slice(-2)}-${(`0${date.getDate()}`).slice(-2)}`;
  }
  return date;
}
